<template>
  <ts-panel>
    <ts-panel-wrapper class="tw-space-y-2">
      <div class="d-flex flex-column align-items-center">
        <ts-image-input
          class="image-input"
          :file="file"
          @input="(file) => (model.photo = file)"
          :width="130"
          :height="168"
          crop
        ></ts-image-input>
        <span class="mt-2"
          ><i>{{ $t("candidateProfile.photo") }}</i></span
        >
        <div style="color: #cc4946; margin: 4px 0 0">
          {{ errors.first("photo") }}
        </div>
      </div>
      <!-- <div>
        <label class="form-col-label control-label required">{{
          $t("candidateProfile.cardNumber")
        }}</label>
        <input
          type="text"
          v-model="model.card_number"
          class="form-control"
          :class="{ 'is-invalid': errors.has('card_number') }"
        />
        <div class="invalid-feedback" v-if="errors.has('card_number')">
          {{ errors.first("card_number") }}
        </div>
      </div> -->
      <div>
        <label class="form-col-label control-label required">{{
          $t("candidateProfile.title")
        }}</label>
        <select
          v-model.trim="model.title"
          class="form-select"
          :class="{ 'is-invalid': errors.has('title') }"
        >
          <option :value="null" selected style="display: none">
            {{ $t("select") }}
          </option>
          <option :value="'Mr'">Mr.</option>
          <option :value="'Mrs'">Mrs.</option>
          <option :value="'Ms'">Ms.</option>
          <option :value="'Miss'">Miss.</option>
        </select>
        <div class="invalid-feedback" v-if="errors.has('title')">
          {{ errors.first("title") }}
        </div>
      </div>
      <div class="row tw-space-y-2">
        <label class="form-col-label control-label required">{{
          $t("trainerProfile.nameKh")
        }}</label>
        <div class="col-md-6">
          <input
            ref="candidate_name_kh"
            type="text"
            v-model="model.fname_kh"
            :placeholder="$t('trainerProfile.fName')"
            class="form-control"
            :class="{ 'is-invalid': errors.has('fname_kh') }"
          />
          <div class="invalid-feedback" v-if="errors.has('fname_kh')">
            {{ errors.first("fname_kh") }}
          </div>
        </div>
        <div class="col-md-6">
          <input
            type="text"
            v-model="model.lname_kh"
            :placeholder="$t('trainerProfile.lName')"
            class="form-control"
            :class="{ 'is-invalid': errors.has('lname_kh') }"
          />
          <div class="invalid-feedback" v-if="errors.has('lname_kh')">
            {{ errors.first("lname_kh") }}
          </div>
        </div>
        <div class="col-md-12">
          <input
            type="text"
            readonly
            v-model="name_kh"
            :placeholder="$t('trainerProfile.fullNameKh')"
            class="form-control"
          />
        </div>
      </div>
      <div class="row tw-space-y-2">
        <label class="form-col-label control-label required">{{
          $t("trainerProfile.nameEn")
        }}</label>
        <div class="col-md-6">
          <input
            type="text"
            v-model="model.fname_en"
            :placeholder="$t('trainerProfile.fName')"
            class="form-control"
            :class="{ 'is-invalid': errors.has('fname_en') }"
          />
          <div class="invalid-feedback" v-if="errors.has('fname_en')">
            {{ errors.first("fname_en") }}
          </div>
        </div>
        <div class="col-md-6">
          <input
            type="text"
            v-model="model.lname_en"
            :placeholder="$t('trainerProfile.lName')"
            class="form-control"
            :class="{ 'is-invalid': errors.has('lname_en') }"
          />
          <div class="invalid-feedback" v-if="errors.has('lname_en')">
            {{ errors.first("lname_en") }}
          </div>
        </div>
        <div class="col-md-12">
          <input
            type="text"
            readonly
            v-model="name_en"
            :placeholder="$t('trainerProfile.fullNameEn')"
            class="form-control"
          />
        </div>
      </div>
      <div>
        <label class="form-col-label control-label required">{{
          $t("candidateProfile.dob")
        }}</label>
        <a-date-picker
          v-model="model.dob"
          style="width: 100%"
          placeholder="DD-MM-YYYY"
          valueFormat="DD-MM-YYYY"
          format="DD-MM-YYYY"
          @change="onChangeDateOfBirth"
        />
      </div>
      <div>
        <label class="form-col-label control-label">{{
          $t("candidateProfile.nationality")
        }}</label>
        <select
          v-model.number="model.nationality_id"
          class="form-select"
          :class="{ 'is-invalid': errors.has('nationality_id') }"
        >
          <option :value="null">{{ $t("select") }}</option>
          <option
            v-for="(nationality, index) in formViewDatas['nationalities']"
            :key="index"
            :value="nationality.nationality_id"
          >
            {{ nationality.nationality_name_en }}
          </option>
        </select>
        <div class="invalid-feedback" v-if="errors.has('nationality_id')">
          {{ errors.first("nationality_id") }}
        </div>
      </div>
      <div class="form-check form-check-inline">
        <input
          class="form-check-input"
          type="radio"
          id="male"
          v-model="model.sex"
          value="Male"
        />
        <label class="form-check-label" for="male">Male</label>
      </div>
      <div class="form-check form-check-inline">
        <input
          class="form-check-input"
          type="radio"
          id="female"
          v-model="model.sex"
          value="Female"
        />
        <label class="form-check-label" for="female">Female</label>
      </div>
      <div class="text-danger" v-if="errors.has('sex')">
        {{ errors.first("sex") }}
      </div>
    </ts-panel-wrapper>
  </ts-panel>
</template>

<script>
import { Errors } from "form-backend-validation";
import { isEmpty } from "lodash";
import { mapState } from "vuex";

export default {
  name: "profile",
  props: ["value", "validate"],
  data() {
    return {
      errors: new Errors(),
      file: require("../../../../assets/staff-default-man.png"),
      model: {},
    };
  },
  computed: {
    ...mapState("academic/candidateProfile", ["edit_data", "formViewDatas"]),
    isEdit() {
      return !isEmpty(this.edit_data);
    },
    name_kh() {
      if (!this.model.fname_kh && !this.model.lname_kh) {
        return null;
      }
      return this.model.fname_kh + " " + this.model.lname_kh;
    },
    name_en() {
      if (!this.model.fname_en && !this.model.lname_en) {
        return null;
      }
      return this.model.fname_en + " " + this.model.lname_en;
    },
  },
  mounted() {
    this.$refs.candidate_name_kh.focus();
  },
  created() {
    this.model = this.value;
  },
  methods: {
    onChangeDateOfBirth(dateString) {
      this.model.dob = dateString;
    },
    setEditData() {
      if (!isEmpty(this.edit_data)) {
        this.model.photo = this.edit_data.photo;
        if (this.model.photo) {
          this.file = this.model.photo;
        }
      }
    },
    clearFile() {
      this.file = require("../../../../assets/staff-default-man.png");
    },
  },
  watch: {
    validate: function (error) {
      this.errors = new Errors(error.errors);
    },
  },
};
</script>
